import { ref } from 'vue'

export function useHomeScrollPosition(itemList) {
    const savedScrollPosition = ref(0)

    const handleScroll = (evt) => {
        savedScrollPosition.value = evt.target.scrollTop
    }

    let scrollListenerAttached = false

    const attachScrollListener = () => {
        if (!itemList?.value || scrollListenerAttached) return
        itemList.value.addEventListener('scroll', handleScroll)
        scrollListenerAttached = true
    }

    const detachScrollListener = () => {
        if (!itemList?.value || !scrollListenerAttached) return
        itemList.value.removeEventListener('scroll', handleScroll)
        scrollListenerAttached = false
    }

    const restoreScroll = () => {
        if (!itemList?.value) return
        itemList.value.scrollTop = savedScrollPosition.value
    }

    return {
        savedScrollPosition,
        attachScrollListener,
        detachScrollListener,
        restoreScroll,
    }
}
